import { render, staticRenderFns } from "./KerkenNavLeft.vue?vue&type=template&id=46d2612f&scoped=true"
import script from "./KerkenNavLeft.vue?vue&type=script&lang=js"
export * from "./KerkenNavLeft.vue?vue&type=script&lang=js"
import style0 from "./KerkenNavLeft.vue?vue&type=style&index=0&id=46d2612f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d2612f",
  null
  
)

export default component.exports